import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "div-table" }

import { computed, ref, watch, type PropType } from 'vue';

import { DivTableColumn, divTableSortDirections } from './div-table-helpers';
import DivTableHeader from './DivTableHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DivTable',
  props: {
  header: { type: Array as PropType<Array<DivTableColumn<unknown>>>, default: () => [] },
  rows: { type: Array as PropType<Array<unknown>>, default: () => [] },
  stickyHeader: { type: Boolean, default: false },
},
  emits: ["header-changed"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalHeader = ref(props.header);

watch(
  () => props.header,
  () => {
    internalHeader.value = props.header;
  },
);

const sortedColumn = computed(() => internalHeader.value?.find((col) => col.sorted));
const sortedRows = computed(() => {
  if (sortedColumn.value === undefined || !sortedColumn.value.sortable) {
    return props.rows;
  }

  const ascSortedRows = props.rows.map((x) => x).sort((a, b) => sortedColumn.value?.sortFunction?.(a, b) || -1);

  return sortedColumn.value?.sortDirection === divTableSortDirections.asc ? ascSortedRows : ascSortedRows.reverse();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.header)
      ? (_openBlock(), _createBlock(DivTableHeader, {
          key: 0,
          value: internalHeader.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((internalHeader).value = $event)),
          class: "x-div-table__header",
          "sticky-header": props.stickyHeader,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (emit('header-changed', $event)))
        }, null, 8, ["value", "sticky-header"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", { rows: sortedRows.value })
  ]))
}
}

})